"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../../../shared/components/table_actions/TableActionDelete");
var WrapTableActions_1 = require("../../../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var FontAwesome_1 = require("../../../../../../../../shared/components/icons/FontAwesome");
var TableMenuIsDeprecated_1 = require("../../../../../../../../shared/components/table_menus/TableMenuIsDeprecated");
var AffilatePayoutList = /** @class */ (function (_super) {
    __extends(AffilatePayoutList, _super);
    function AffilatePayoutList(props) {
        return _super.call(this, props) || this;
    }
    AffilatePayoutList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            totalRows: 0,
        }, function () {
            _this.props.data.LoadData(_this.props.rootRecord.key);
        });
    };
    AffilatePayoutList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    AffilatePayoutList.prototype.doDeprecateAction = function (key, title, deprecate) {
        this.props.data.DoSetIsDeprecated(key, deprecate, function () {
            if (deprecate) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0422\u0438\u043F \u0432\u044B\u043F\u043B\u0430\u0442\u044B \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0441\u043A\u043E\u0439 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B ",
                    React.createElement("b", null,
                        "[",
                        title,
                        "]"),
                    " \u043E\u0442\u043C\u0435\u0447\u0435\u043D \u043A\u0430\u043A \u0443\u0441\u0442\u0430\u0440\u0435\u0432\u0448\u0438\u0439"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0422\u0438\u043F \u0432\u044B\u043F\u043B\u0430\u0442\u044B \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0441\u043A\u043E\u0439 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B ",
                    React.createElement("b", null,
                        "[",
                        title,
                        "]"),
                    " \u043E\u0442\u043C\u0435\u0447\u0435\u043D \u043A\u0430\u043A \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u044B\u0439"));
            }
        });
    };
    AffilatePayoutList.prototype.getColumns = function () {
        var _this = this;
        return ([{
                title: 'Бренд',
                dataIndex: this.props.data.dk_app_payout_id,
                key: this.props.data.dk_app_payout_id,
                width: 200,
                render: function (text, record, idx) {
                    return React.createElement("div", null,
                        React.createElement(FontAwesome_1.FA, { right: true, icon: "registered" }),
                        " ",
                        _this.props.rootRecord.title);
                }
            }, {
                title: 'Тип выплаты',
                dataIndex: this.props.data.dk_app_payout_title,
                key: this.props.data.dk_app_payout_title,
                width: 150,
                render: function (text, record, index) {
                    return (React.createElement("div", null,
                        record.app_payout_title,
                        " ",
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "credit-card" })));
                }
            }, {
                title: 'Валюта',
                dataIndex: this.props.data.dk_app_currency_title,
                key: this.props.data.dk_app_currency_title,
                width: 150,
                render: function (text, record, index) {
                    return (React.createElement("div", null, record.app_currency_title));
                }
            }, {
                title: 'Добавлена',
                dataIndex: this.props.data.dk_date_added2,
                key: this.props.data.dk_date_added2,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added2.format(_this.props.state.getDateTimeFormat())));
                }
            }, {
                title: 'Устаревший',
                dataIndex: this.props.data.dk_is_deprecated,
                key: this.props.data.dk_is_deprecated,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsDeprecated_1.default, { deprecatedTexts: { menu: "Пометить как устаревший", text: "Да" }, notDeprecatedTexts: { menu: "Пометить как актуальный", text: "Нет" }, record: { key: record.key, title: record.app_payout_title, deprecated: record.is_deprecated }, onDeprecateClick: _this.doDeprecateAction.bind(_this) }));
                },
                width: 120,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeletePlayerClick(record); } }))); },
                width: 80
            }
        ]);
    };
    AffilatePayoutList.prototype.onEditDataClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    AffilatePayoutList.prototype.onDeletePlayerClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0422\u0438\u043F \u0432\u044B\u043F\u043B\u0430\u0442\u044B \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0441\u043A\u043E\u0439 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B ",
                React.createElement("b", null,
                    "[",
                    record.app_payout_title,
                    "]"),
                " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D"));
        });
    };
    AffilatePayoutList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData(this.props.rootRecord.key);
        }
        if (action === "create") {
            if (this.props.onCreateClick) {
                this.props.onCreateClick();
            }
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    AffilatePayoutList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить", back: "Назад" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { bordered: true, columns: this.getColumns(), dataSource: this.state.data, locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, pagination: {
                    pageSize: this.props.state.UITablePageSize,
                    showSizeChanger: true,
                    total: this.state.totalRows,
                    position: "bottom",
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) { return React.createElement("div", { style: { margin: 0 } },
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                        " [",
                        record.key,
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                        " [",
                        record.date_added2.format(_this.props.state.getDateTimeFormat()),
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                        " [",
                        record.date_changed2.format(_this.props.state.getDateTimeFormat()),
                        "]")); } })));
    };
    return AffilatePayoutList;
}(React.Component));
exports.default = AffilatePayoutList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_pprograms_list/ui/component/config/payout/AffilatePayoutList.tsx
// module id = 2024
// module chunks = 0